<app-dialog-header [title]="title" (onClick)="dialogRef.close(false)"></app-dialog-header>

<div mat-dialog-content class="form-wrapper" fxLayout="column" fxLayoutAlign="start">
    <form name="eventForm" [formGroup]="eventForm" class="event w-100-p p-24" fxLayout="column">
        <mat-form-field class="w-100-p choose-date-field">
            <mat-label>{{ 'FORM.EVENT.FIELD.NAME' | translate }}</mat-label>
            <input matInput name="name" formControlName="name" [placeholder]="'FORM.EVENT.FIELD.NAME' | translate" />
        </mat-form-field>

        <mat-form-field class="w-100-p choose-date-field">
            <mat-label>{{ 'GENERAL.PROPERTY.CHOOSE_DATE' | translate }}</mat-label>
            <div formGroupName="startEndDate">
                <mat-date-range-input [rangePicker]="picker">
                    <input
                        matStartDate
                        formControlName="startDate"
                        autocomplete="off"
                        readonly
                        inputmode="none"
                        (click)="picker.open()"
                        (focus)="picker.open()"
                    />
                    <input
                        matEndDate
                        formControlName="endDate"
                        autocomplete="off"
                        readonly
                        inputmode="none"
                        (click)="picker.open()"
                        (focus)="picker.open()"
                    />
                </mat-date-range-input>
            </div>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field>

        <div fxLayout="column" fxLayout.gt-xs="row" fxLayoutGap="0" fxLayoutGap.gt-xs="6%">
            <mat-form-field fxFlex="1 0 100%" fxFlex.gt-xs="1 0 47%">
                <mat-label>{{ 'GENERAL.PROPERTY.START_TIME' | translate }}</mat-label>
                <input matInput [cleave]="{ time: true, timePattern: ['h', 'm'] }" formControlName="startTime" />
                <mat-icon class="timepicker-icon">access_time</mat-icon>
            </mat-form-field>

            <mat-form-field fxFlex="1 0 100%" fxFlex.gt-xs="1 0 47%">
                <mat-label>{{ 'GENERAL.PROPERTY.END_TIME' | translate }}</mat-label>
                <input matInput [cleave]="{ time: true, timePattern: ['h', 'm'] }" formControlName="endTime" />
                <mat-icon class="timepicker-icon">access_time</mat-icon>
            </mat-form-field>
        </div>

        <mat-form-field class="w-100-p">
            <input matInput id="location" [placeholder]="'LOCATION.SINGULAR' | translate" aria-label="Location" [matAutocomplete]="auto" formControlName="location" />
            <mat-autocomplete #auto="matAutocomplete">
                <mat-option *ngFor="let location of locations" [value]="location.name">
                    <span>{{ location.name }}</span>
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>

        <mat-form-field class="w-100-p event-description-field" appearance="outline">
            <mat-label>{{ 'FORM.EVENT.FIELD.DESCRIPTION' | translate }}</mat-label>
            <textarea
                matInput
                class="event-description"
                [value]="eventForm.value.description | htmlToPlaintext"
                readonly
                rows="6"
                (click)="editDescription()"
            ></textarea>
        </mat-form-field>

        <div fxLayout="column" *ngIf="isModuleFeatureAttendanceActive && isModuleEvent && (moduleKind === ModuleKind.Normal || moduleKind === ModuleKind.Execution)">
            <mat-label class="mt-24 attendance-tracking-label">{{ 'FORM.EVENT.FIELD.ATTENDANCE_TRACKING' | translate }}</mat-label>
            <span>{{ 'FORM.EVENT.FIELD.ATTENDANCE_TRACKING_DESCRIPTION' | translate }}</span>
            <mat-checkbox class="enable-attendance-tracking-label mt-24" formControlName="trackAttendance">
                {{ 'FORM.EVENT.FIELD.ENABLE_ATTENDANCE_TRACKING' | translate }}
            </mat-checkbox>
        </div>
    </form>
</div>

<div mat-dialog-actions class="pt-24 action-buttons" fxLayout="row" fxLayoutAlign="end center">
    <app-white-button class="mr-8" [label]="'GENERAL.BUTTON.CANCEL'" (onClick)="dialogRef.close()"></app-white-button>

    <app-flat-button [label]="'GENERAL.BUTTON.SAVE'" (onClick)="save()" [disabled]="eventForm.invalid"></app-flat-button>
</div>
